
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("ember-tracked-storage-polyfill/index", function(){ return i("ember-tracked-storage-polyfill/index");});
d("@embroider/macros/es-compat2", function(){ return i("@embroider/macros/es-compat2");});
d("@embroider/macros/runtime", function(){ return i("@embroider/macros/runtime");});
d("@ember/render-modifiers/modifiers/did-insert", function(){ return i("@ember/render-modifiers/modifiers/did-insert");});
d("@ember/render-modifiers/modifiers/did-update", function(){ return i("@ember/render-modifiers/modifiers/did-update");});
d("@ember/render-modifiers/modifiers/will-destroy", function(){ return i("@ember/render-modifiers/modifiers/will-destroy");});
d("ember-cached-decorator-polyfill/index", function(){ return i("ember-cached-decorator-polyfill/index");});
d("pretty-text/allow-lister", function(){ return i("pretty-text/allow-lister");});
d("pretty-text/censored-words", function(){ return i("pretty-text/censored-words");});
d("pretty-text/emoji", function(){ return i("pretty-text/emoji");});
d("pretty-text/emoji/data", function(){ return i("pretty-text/emoji/data");});
d("pretty-text/emoji/version", function(){ return i("pretty-text/emoji/version");});
d("pretty-text/guid", function(){ return i("pretty-text/guid");});
d("pretty-text/inline-oneboxer", function(){ return i("pretty-text/inline-oneboxer");});
d("pretty-text/mentions", function(){ return i("pretty-text/mentions");});
d("pretty-text/oneboxer-cache", function(){ return i("pretty-text/oneboxer-cache");});
d("pretty-text/oneboxer", function(){ return i("pretty-text/oneboxer");});
d("pretty-text/pretty-text", function(){ return i("pretty-text/pretty-text");});
d("pretty-text/sanitizer", function(){ return i("pretty-text/sanitizer");});
d("pretty-text/text-replace", function(){ return i("pretty-text/text-replace");});
d("pretty-text/upload-short-url", function(){ return i("pretty-text/upload-short-url");});
d("ember-buffered-proxy/helpers", function(){ return i("ember-buffered-proxy/helpers");});
d("ember-buffered-proxy/mixin", function(){ return i("ember-buffered-proxy/mixin");});
d("ember-buffered-proxy/proxy", function(){ return i("ember-buffered-proxy/proxy");});
d("ember-cli-app-version/initializer-factory", function(){ return i("ember-cli-app-version/initializer-factory");});
d("ember-cli-app-version/utils/regexp", function(){ return i("ember-cli-app-version/utils/regexp");});
import "ember-curry-component/-embroider-implicit-modules.js";
import "ember-route-template/-embroider-implicit-modules.js";
import "ember-source/-embroider-implicit-modules.js";
import "@ember-compat/tracked-built-ins/-embroider-implicit-modules.js";
import "@ember/test-helpers/-embroider-implicit-modules.js";
import "@ember/test-waiters/-embroider-implicit-modules.js";
import "@embroider/router/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "discourse-i18n/-embroider-implicit-modules.js";
import "discourse-markdown-it/-embroider-implicit-modules.js";
import "ember-async-data/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-cli-deprecation-workflow/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-qunit/-embroider-implicit-modules.js";
import "ember-cli-inject-live-reload/-embroider-implicit-modules.js";
import "custom-proxy/-embroider-implicit-modules.js";
import "ember-tracked-storage-polyfill/-embroider-implicit-modules.js";
import "@ember/optional-features/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "@ember/render-modifiers/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "ember-cached-decorator-polyfill/-embroider-implicit-modules.js";
import "ember-template-imports/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "pretty-text/-embroider-implicit-modules.js";
import "discourse-plugins/-embroider-implicit-modules.js";
import "ember-buffered-proxy/-embroider-implicit-modules.js";
import "ember-cli-app-version/-embroider-implicit-modules.js";
import "ember-test-selectors/-embroider-implicit-modules.js";
import "ember-cli-progress-ci/-embroider-implicit-modules.js";
import "broccoli-asset-rev/-embroider-implicit-modules.js";
import "ember-cli-terser/-embroider-implicit-modules.js";
import "ember-cli-sri/-embroider-implicit-modules.js";
import "ember-decorators/-embroider-implicit-modules.js";
import "ember-exam/-embroider-implicit-modules.js";
import "loader.js/-embroider-implicit-modules.js";
